export default "__VITE_ASSET__2ebb7717__"